import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function InvolvementTypeRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/involvement-type', component: Index, isProtected: true, permissions: ['involvement_type_index']},
    {path: '/involvement-type/create', component: Create, isProtected: true, permissions: ['involvement_type_create']},
    {path: '/involvement-type/edit/:id', component: Edit, isProtected: true, permissions: ['involvement_type_edit']},

  ];

  return routes;
}
